<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Sınıflarımız" />
        <CoursesList pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import CoursesList from '../Classes/ClassesList'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'CoursesPageFour',
    components: {
    Navbar,
    PageTitle,
    CoursesList,
    Footer,
    BuyNow
},
}
</script>